import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { Api } from '@services';

interface App {
  id: number;
  name: string;
}

interface AppSwitcherState {
  isHidden: boolean;
  searchTerm: string;
  currentDefaultApp: number | null;

  setHidden: (hidden: boolean) => void;
  setSearchTerm: (term: string) => void;
  hydrateFromBE: (defaultAppId: number | null) => void;

  setDefaultApp: (app: App) => Promise<void>;
}

export const useAppSwitcherStore = create<AppSwitcherState>()(
  persist(
    (set) => ({
      isHidden: false,
      searchTerm: '',
      currentDefaultApp: null,

      setHidden: (hidden) => set({ isHidden: hidden }),
      setSearchTerm: (term) => set({ searchTerm: term }),

      hydrateFromBE: (defaultAppId) =>
        set({ currentDefaultApp: defaultAppId ?? null }),

      setDefaultApp: async (app) => {
        try {
          await Api.put('/users', { DefaultApplicationId: app.id });

          set({ currentDefaultApp: app.id });
        } catch (err) {
          console.error('❌ Failed to update default app', err);
        }
      },
    }),
    {
      name: 'app-switcher-storage',
      partialize: (state) => ({
        isHidden: state.isHidden,
        searchTerm: state.searchTerm,
      }),
    },
  ),
);
